import { __assign } from "tslib";
import * as ColorUtils from '../color';
import { PropertyClass } from '../types';
import { BlendMode, FillRule } from './types';
function create(content, fillPartial) {
    if (fillPartial === void 0) { fillPartial = {}; }
    return __assign({ blendMode: BlendMode.Normal, className: PropertyClass.Fill, content: content, enabled: true }, fillPartial);
}
export function createFillStyle(partial) {
    if (partial === void 0) { partial = {}; }
    return __assign({ fillRule: FillRule.Nonzero, fills: [] }, partial);
}
export function createColorFill(fromColor, options) {
    if (fromColor === void 0) { fromColor = ColorUtils.create(); }
    if (options === void 0) { options = {}; }
    return create(fromColor, __assign({}, options));
}
// TODO: make this work with other types of fill (needs easel update)
export function getOpacity(fill) {
    return ColorUtils.getOpacity(fill.content);
}
export function getEnabled(fill) {
    return fill.enabled;
}
export function colorFillToHex(fill) {
    return ColorUtils.rgbaToHex(fill.content.rgbaValues);
}
export function hexToColorFill(hex) {
    return createColorFill(ColorUtils.createFromHex(hex));
}
export function isColorFill(fill) {
    return fill.content.className === PropertyClass.Color;
}
export function isPatternFill(fill) {
    return fill.content.className === PropertyClass.Pattern;
}
/**
 * @deprecated
 * TODO: Pattern is being used as token storage temporarily
 */
export function isTokenInstanceFill(fill) {
    return isPatternFill(fill);
}
